// 此文件不要动
export const nameComponentObj = {
  "logLoginManage": {
    name: "logLoginManage",
    label: "日志管理/登录日志",
    permissionIdentification: "log:login:list", // 权限标识
    recycleBinIdentification: "Log.LoginLog", // 数据库表权限标识 回收站使用
    component: () => import(/* webpackChunkName: "logModule" */"@/views/log/login-log")
  },
  "logOperateManage": {
    name: "logOperateManage",
    label: "日志管理/操作日志",
    permissionIdentification: "log:operate:list", // 权限标识
    recycleBinIdentification: "Log.OperateLog", // 数据库表权限标识 回收站使用
    component: () => import(/* webpackChunkName: "logModule" */"@/views/log/operate-log")
  },
  "logScheduleManage": {
    name: "logScheduleManage",
    label: "日志管理/定时任务日志",
    permissionIdentification: "log:schedule:list", // 权限标识
    recycleBinIdentification: "Log.ScheduleLog", // 数据库表权限标识 回收站使用
    component: () => import(/* webpackChunkName: "logModule" */"@/views/log/schedule-log")
  }
}

// 没有按钮权限标识数据 也要暴露一个对象出去
export const btnObj = {
  logOperateRead: {
    label: "日志管理/操作日志/查看日志",
    value: "log:operate:read"
  },
  logLoginRead: {
    label: "日志管理/登录日志/查看日志",
    value: "log:login:read"
  },
  logScheduleRead: {
    label: "日志管理/任务日志/查看日志",
    value: "log:schedule:read"
  },
  logLoginDelete: {
    label: "日志管理/登录日志/删除日志",
    value: "log:login:delete"
  },
  logOperateDelete: {
    label: "日志管理/操作日志/删除日志",
    value: "log:operate:delete"
  },
  logScheduleDelete: {
    label: "日志管理/任务日志/删除日志",
    value: "log:schedule:delete"
  },
  logLoginDeleteAll: {
    label: "日志管理/登录日志/全部删除",
    value: "log:login:deleteAll"
  },
  logOperateDeleteAll: {
    label: "日志管理/操作日志/全部删除",
    value: "log:operate:deleteAll"
  },
  logScheduleDeleteAll: {
    label: "日志管理/任务日志/全部删除",
    value: "log:schedule:deleteAll"
  }
}